module.exports = __webpack_public_path__ + "static/icon-about-480px-ef1fb8406607ac017c59a589901e2931.png";